import $ from 'jquery';

export const init = ($target) => {

	$(document)
		.on('click', '.inp-custom-select__select', function(e) {
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.inp-custom-select');

			$closest.toggleClass('is-open');
		})
		.on('click', function(e) {
			if ( ! $( e.target ).closest('.inp-custom-select').length ) {
				$('.inp-custom-select').removeClass('is-open');
			}
		})
		.on('change', '.inp-custom-select .inp-item__inp', function(e) {
			var $this = $(this),
				$closest = $this.closest('.inp-custom-select'),
				$select = $closest.find('.inp-custom-select__select'),
				$selectWrap = $closest.find('.inp-custom-select__select-wrap'),
				$parent = $this.parent(),
				$active = $parent.find('.inp-item__text').clone();

			// if called by b-tabs, check manualy
			$this.prop('checked', true);

			$selectWrap.html('<span class="inp-custom-select__item inp-item">' + $active.html() + '</span>');
			$closest.removeClass('is-open');

		});

};
